<template>
  <div class="foodDetails">
    <div class="details-top">
      <img class="back" src="../../assets/images/back_black.png" alt="" @click="backPage">
      <img class="food-img" :src="image" alt="">
    </div>
    <div class="wrap">
      <div class="food-info">
        <div class="name twoClampEllipsis">
          {{ name }}
        </div>
        <div class="remark twoClampEllipsis">{{ remark }}</div>
        <div class="addCart">
          <div class="price">
            <span>￥</span>
            <span>{{ price }}</span>
          </div>
          <div class="btn" @click="onClickAdd">加入购物车</div>
        </div>
      </div>
      <div class="detail" v-if="detail !== ''">
        <div class="title">商品详情</div>
        <div class="info" v-html="$xss(detail)"></div>
      </div>
    </div>
    <!--底部购物车-->
    <div class="order" v-show="!productSpec">
      <div class="car-box">
        <div class="car" @click="getCartList(true)">
          <img src="../../assets/images/menu/order_cart.png" alt="">
          <div class="num" v-if="number">{{ number }}</div>
        </div>
        <div class="price">
          <span>￥</span>
          <span>{{ amount }}</span>
        </div>
      </div>
      <div class="goSettle" :class="mealStatus===1?'settleBlueBg':'settleGrayBg'" @click="goOrder">
        {{ mealStatus === 0 ? '订餐未开始' : mealStatus === 1 ? '去结算' : '订餐已截止' }}
      </div>
    </div>
    <!--购物车列表弹框-->
    <van-popup position="bottom" round v-model="cartPopup"
               style="padding-bottom: 60px;box-sizing: border-box;max-height: 500px;">
      <div class="cartPopup">
        <div class="car-title">
          <span>已选商品</span>
          <span @click="clearCart">清空</span>
        </div>
        <div class="car-list" v-if="cartList.length !==0">
          <div class="cart-box">
            <single-food :foodArr="cartList" @showSpecs="openProductSpecs" :mealId="mealId"
                         :func="addCart"></single-food>
          </div>
        </div>
        <div class="noMore" v-else>
          <span>没有更多了...</span>
        </div>
      </div>
    </van-popup>
    <!--商品规格弹框-->
    <van-popup position="bottom" round v-model="productSpec" @close="close">
      <div class="productSpec">
        <div class="productSpec-box">
          <div class="product-top">
            <div class="product-img">
              <img :src="attrFood.image" alt="">
            </div>
            <div class="product-info">
              <div class="product">
                <span class="name oneClampEllipsisType1">{{ attrFood.goodsName }}</span>
                <span class="material twoClampEllipsis">{{ attrFood.remark }}</span>
              </div>
              <div class="price">
                <span>￥</span>
                <span>{{ attrFood.price }}</span>
              </div>
            </div>
          </div>
          <div class="number">
            <span class="text">数量</span>
            <div class="toggle-number">
              <img src="../../assets/images/menu/sub.png" alt="" class="sub" @click="addFood(0)" v-if="num !==0">
              <div class="count" v-if="num !==0">{{ num }}</div>
              <img src="../../assets/images/menu/add.png" alt="" class="add" @click="addFood(1)">
            </div>
          </div>
          <div class="choose-box" v-for="(attr,index1) in attrArr" :key="index1">
            <div class="little-title">{{ attr.attrGroupName }}</div>
            <div class="choose-item">
              <span v-for="(i,index2) in attr.attrs" :key="index1+index2"
                    :class="selectAttrBtn[index1].select===index2?'selectAttr':''"
                    @click="selectAttr({id:i.attrId,index1:index1,index2:index2})">
                {{ i.attrName }}
              </span>
            </div>
          </div>
        </div>
        <div class="addBtn">
          <button @click="addCart({mealId,goodsId,skuId,num,fromAttr})">加入购物车</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import singleFood from "../../components/singleFood";

export default {
  name: "goodsDetails",
  components: {singleFood},
  data() {
    return {
      image: "",
      name: "",
      remark: "",
      price: '0.00',
      detail: ``,
      goodsId: null,
      bedName: '',
      mealId: 0,
      userAttr: false,//是否需要商品规格
      number: 0,
      amount: 0,
      mealStatus: 0,
      cartPopup: false,
      cartList: [],
      productSpec: false,
      attrFood: {},
      num: 1,
      attrArr: [],
      attrId: [],
      selectAttrBtn: [],//控制规格样式
      fromAttr: false,//判断是否是规格
      skuId: null
    }
  },
  created() {
    this.mealId = Number(sessionStorage.getItem('mealId'));
    this.goodsId = Number(this.$route.query.id);
    this.bedName = this.$route.query.bedName;
    this.getFoodDetail(this.goodsId);
    this.getNowTime();
  },
  beforeDestroy() {
    sessionStorage.removeItem('mealId');
  },
  methods: {
    //关闭规格
    close() {
      this.productSpec = false;
      this.num = 1;
    },
    addFood(isAdd) {
      if (isAdd) {
        this.num++;
      } else {
        if (this.num <= 1) {
          this.num = 1;
        } else {
          this.num--;
        }
      }
    },
    //去结算
    goOrder() {
      if (!this.bedName) {
        return Toast('请选择地址');
      }
      if (this.number == 0) {
        return Toast('您还没选择餐品，请先选择');
      }
      if (this.mealStatus === 1) {
        this.$router.push({path: "/order"});
      }
    },
    //清空购物车
    clearCart() {
      if (this.cartList.length === 0) {
        return Toast('购物车还没有添加商品')
      }
      Dialog.confirm({
        message: "确定清空购物车吗？",
        confirmButtonColor: '#126AFC',
        overlayStyle: {'zIndex': '2004 !important'},
      }).then(() => {
        this.$post('cart/deleteAll').then(res => {
          if (res.status === 200) {
            Toast('购物车已清空！');
            this.getCartList();
            this.cartPopup = false;
          } else {
            Toast(res.msg);
          }
        })
      }).catch(() => {
      })
    },
    //打开商品规格(接收子组件传递的id)
    openProductSpecs(id) {
      this.goodsId = id;
      //重置规格数组
      this.attrId = [];
      this.selectAttrBtn = [];
      //获取商品规格数据
      this.$post('goods/attrList', {goodsId: id}).then(result => {
        if (result.status === 200) {
          this.attrArr = result.data;
          this.attrArr.map((i) => {
            //生成控制规格样式的数组
            this.selectAttrBtn.push({select: 0});
            //生成规格组id
            this.attrId.push(i.attrs[0].attrId);
          })
          //默认规格获取数据
          this.selectAttr({flag: false});
          //打开规格弹框
          // sessionStorage.setItem('num', 0);
          this.productSpec = true;
        }
      });
    },
    //添加购物车
    addCart({mealId, goodsId, isAdd = 1, skuId = 0, num = null, fromAttr}) {
      //fromAttr 判断是否是选规格进入
      if (fromAttr && !num) {
        return Toast('请选择商品数量');
      }
      const data = {
        mealId,
        goodsId,
        isAdd,
        skuId,
        num
      }
      this.$post('cart/edit', data).then(result => {
        if (result.status === 200) {
          if (fromAttr) {
            this.close();
          }
          Toast('添加成功');
          this.getCartList();
        } else {
          Toast(result.msg);
          this.close();
        }
      });
    },
    //返回上一页
    backPage() {
      this.$router.replace('/food/menu');
    },
    //选择规格
    selectAttr({index1 = 0, index2 = 0, id = 0, flag = true}) {
      //flag 是否需要修改
      if (flag) {
        this.attrId[index1] = id;
        this.selectAttrBtn[index1].select = index2;
      }
      let attrIds = '';
      if (this.attrId.length > 1) {
        attrIds = this.attrId.join(',')
      } else {
        attrIds = attrIds + this.attrId[0];
      }

      const data = {
        attrIds,
        goodsId: this.goodsId
      }
      this.$post('goods/selectAttr', data).then(result => {
        if (result.status === 200) {
          this.skuId = result.data.skuId;
          this.attrFood = result.data;
        }
      });
    },
    //获取规格
    getGoodsAttr() {
      this.$post('goods/attrList', {goodsId: this.goodsId}).then(result => {
        if (result.status === 200) {
          this.attrArr = result.data;
          this.attrArr.map((i) => {
            //生成控制规格样式的数组
            this.selectAttrBtn.push({select: 0});
            //生成规格组id
            this.attrId.push(i.attrs[0].attrId);
          })
          //默认规格获取数据
          this.selectAttr({flag: false});
          //打开规格弹框
          // sessionStorage.setItem('num', 0);
          this.productSpec = true;
        }
      });
    },
    //点击添加购物车
    onClickAdd() {
      if (this.userAttr) {
        this.productSpec = true;
        this.getGoodsAttr();
      } else {
        let mealId = this.mealId;
        let goodsId = this.goodsId;
        this.addCart({mealId, goodsId});
      }
    },
    //获取购物车列表
    getCartList(flag = false) {
      this.$post('cart/list', {mealId: this.mealId}).then(result => {
        if (result.data.cartInfo) {
          this.number = result.data.cartInfo.num;
          this.amount = result.data.cartInfo.amount;
          //flag 判断是否需要打开弹框
          if (flag) {
            this.cartPopup = true;
          }
          this.cartList = result.data.goodsInfo;
        }
      });
    },
    //获取当前时段
    getNowTime() {
      this.$post('meal/nowTime').then(result => {
        this.mealStatus = result.data.mealStatus;
        sessionStorage.setItem('mealId', result.data.mealId);
        this.getCartList();
      });
    },
    //商品详情
    getFoodDetail(goodsId) {
      this.$post('goods/detail', {goodsId}).then(result => {
        let {image, name, remark, price, detail, userAttr} = result.data;
        this.image = image;
        this.name = name;
        this.remark = remark;
        this.price = price;
        this.detail = detail;
        this.userAttr = userAttr;
        this.fromAttr = userAttr;
      });
    }
  }
}
</script>
<style>
.van-overlay {
  z-index: 2000 !important;
}

.van-popup {
  z-index: 2002 !important;
}
</style>
<style scoped lang="less">
.foodDetails {
  font-size: 12px;
  padding-bottom: 80px;
  position: relative;

  .details-top {
    width: 100%;

    .food-img {
      width: 100%;
      height: 365px;
    }

    .back {
      width: 10px;
      height: 20px;
      position: fixed;
      left: 15px;
      top: 15px;
    }
  }

  .wrap {
    padding: 0 15px;
    box-sizing: border-box;

    .food-info {
      margin-top: 15px;
      background: #FFFFFF;
      border-radius: 8px;
      padding: 20px 15px 15px 15px;
      box-sizing: border-box;

      .name {
        width: 300px;
        line-height: 28px;
        font-size: 20px;
        font-weight: bold;
        color: #000000;
      }

      .remark {
        width: 300px;
        color: #999999;
        margin-top: 15px;
      }

      .addCart {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 22px;
        color: #FC3912;

        span:nth-child(2) {
          font-size: 24px;
          font-weight: bold;
        }

        .btn {
          width: 90px;
          height: 30px;
          background: #126AFC;
          border-radius: 11px;
          color: #FFFFFF;
          text-align: center;
          line-height: 30px;
          font-weight: bold;
        }
      }
    }

    .detail {
      width: 100%;
      margin-top: 15px;
      background: #FFFFFF;
      padding: 15px 15px 30px 15px;
      box-sizing: border-box;
      border-radius: 8px;
      font-size: 13px;

      .title {
        font-size: 15px;
        font-weight: bold;
      }

      .info {
        margin-top: 25px;
        color: #000000;

        .info-item {
          margin-top: 15px;

          span:nth-child(1) {
            font-weight: bold;
          }

          span:nth-child(2) {
            margin-left: 5px;
          }
        }
      }
    }
  }

  .order {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    z-index: 2003;

    .car-box {
      display: flex;
      align-items: center;

      .car {
        width: 50px;
        height: 50px;

        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 50px;
          height: 50px;
        }

        .num {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #FC3912;
          text-align: center;
          line-height: 20px;
          color: #FFFFFF;
          font-weight: bold;
          position: absolute;
          top: -4px;
          right: -4px;
        }
      }

      .price {
        display: flex;
        align-items: flex-end;
        font-weight: bold;
        font-size: 12px;
        margin-left: 16px;

        span:nth-child(2) {
          font-size: 20px;
        }
      }
    }

    .goSettle {
      width: 110px;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      font-weight: bold;
      text-align: center;
      line-height: 40px;
      color: #FFFFFF;
    }

    .settleBlueBg {
      background: #126AFC;
    }

    .settleGrayBg {
      background: #CCCCCC;
    }
  }

  .cartPopup {
    max-height: 500px;
    overflow: hidden;
    padding: 0 15px;
    box-sizing: border-box;

    .car-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      font-size: 15px;
      padding: 20px 0;

      span:nth-child(1) {
        font-weight: bold;
        color: #000000;
      }

      span:nth-child(2) {
        color: #999999;
      }
    }

    .car-list {
      overflow: hidden;
      margin-top: 20px;


      .cart-box {
        height: 100%;
        overflow-y: scroll;
        scroll-behavior: smooth;
      }

      .cart-box::-webkit-scrollbar {
        display: none;
      }
    }

    .noMore {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #CCCCCC;
      padding-bottom: 60px;
    }
  }

  .productSpec {
    width: 100vw;
    overflow: hidden;
    padding: 0 15px;
    background: #FFFFFF;
    box-sizing: border-box;
    position: relative;

    .productSpec-box {
      max-height: 500px;
      overflow-y: scroll;
      scroll-behavior: smooth;

      .product-top {
        display: flex;
        margin-top: 20px;

        .product-img {
          width: 90px;
          height: 90px;
          min-height: 60px;
          border-radius: 5px;
          overflow: hidden;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .product-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 10px;
          font-size: 12px;

          .product {
            display: flex;
            flex-direction: column;

            .name {
              width: 100%;
              font-size: 15px;
              font-weight: bold;
              margin-top: 3px;
              color: #000000;
            }

            .material {
              margin-top: 10px;
              color: #999999;
            }
          }

          .price {
            color: #FC3912;
            font-size: 12px;
            font-weight: bold;

            span:nth-child(2) {
              font-size: 20px;
            }
          }
        }
      }

      .number {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 14px;
        }

        .toggle-number {
          display: flex;
          align-items: center;

          .sub {
            width: 20px;
            height: 20px;
          }

          .count {
            font-size: 15px;
            font-weight: bold;
            margin: 0 12px;
          }

          .add {
            width: 20px;
            height: 20px;
          }
        }
      }

      .choose-box:last-child {
        padding-bottom: 80px;
      }

      .choose-box {
        margin-top: 25px;

        .little-title {
          font-size: 14px;
        }

        .choose-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 15px;
          flex-wrap: wrap;

          .selectAttr {
            background: #E6EFFF;
            border: 1px solid #126AFC;
            color: #126AFC;
          }

          span {
            width: 108px;
            height: 38px;
            background: #EEEEEE;
            font-size: 14px;
            line-height: 38px;
            text-align: center;
            margin-bottom: 10px;
            border-radius: 7px;
            margin-left: 6px;
            box-sizing: border-box;
          }
        }
      }
    }

    .addBtn {
      width: calc(100vw - 30px);
      position: absolute;
      bottom: 10px;
      box-sizing: border-box;

      button {
        width: 100%;
        height: 40px;
        background: #00aaee;
        color: #FFFFFF;
        border: none;
        border-radius: 25px;

      }
    }

    .productSpec-box::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>